var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRaw = function SvgIconRaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_raw_svg__a",
    x1: 0,
    y1: 0,
    x2: 48,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 11,
    fill: "url(#icon_raw_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11h13a3.5 3.5 0 0 1 3.5 3.5V37l-10-7.27L14 37V14.5a3.5 3.5 0 0 1 3.5-3.5z",
    fill: "#fff"
  })));
};
export default SvgIconRaw;